import React from 'react';
import '../App.css';

const ContentWrapperUI = ({ component, paddingStyle, backgroundColor }) => (
  <div className="component-wrapper" style={{backgroundColor}}>
    <div className="component-box" style={paddingStyle}>
      {component}
    </div>
  </div>
);

export default ContentWrapperUI;